export default function DiscountIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
      <path data-name="Path 2739" d="M0 0h16v16H0Z" fill="none" />
      <path
        data-name="Path 2740"
        d="m14.587 7.706-6.3-6.3A1.391 1.391 0 0 0 7.3 1H2.4A1.4 1.4 0 0 0 1 2.4v4.9a1.4 1.4 0 0 0 .413.994l6.3 6.3A1.391 1.391 0 0 0 8.7 15a1.369 1.369 0 0 0 .987-.413l4.9-4.9A1.369 1.369 0 0 0 15 8.7a1.414 1.414 0 0 0-.413-.994ZM3.45 4.5A1.05 1.05 0 1 1 4.5 3.45 1.049 1.049 0 0 1 3.45 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
